import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData(state, action) {
      const { payload } = action;
      state.user = payload;
    },
    clearUser(state) {
      state.user = null;
    },
  },
});

export const { setUserData, clearUser } = authSlice.actions;
export default authSlice.reducer;
